/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import './style.scss';
import { Popover, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faPlay } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

/**
 *
 */

function MetricView({
  data, loading, MONEY, selectedTenant, title, value, percentage, type, helpText,
}) {
  const content = (
    <div style={{ width: '400px', padding: '0.5px', margin: '0px' }}>
      {helpText?.length > 1 ? (
        <ul>
          {helpText.map((text) => <li>{text}</li>)}
        </ul>
      ) : helpText ? <H3Text text={helpText[0]} /> : ''}
    </div>
  );

  return (
    <div className="metric-with-amount-split__wrapper">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-view">
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <H3Text text={`${title}`} className="metric-view__title" />
          &nbsp;

          {(helpText
          && (
            <Popover content={content} placement="bottom">
              <FontAwesomeIcon icon={faInfoCircle} className="info-icon" style={{ color: '#008FFB', fontSize: '10px' }} />
            </Popover>
          )
          )}
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '5px',
        }}
        >
          <H3Text text={type === 'AMOUNT' ? MONEY(value || '0').split('.')[0] : type === 'PERCENTAGE' ? `${value}%` : value?.toFixed(2)} className={`metric-view__value ${value < 0 ? 'metric-view__value-red' : ''}`} />
          {percentage ? <span className={`table-subscript ${percentage < 0 ? 'table-subscript-red' : 'table-subscript-green'}`}>{`${percentage > 0 ? '+' : ''}${percentage}%`}</span> : ''}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
});

MetricView.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
  helpText: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricView));
